import { useEffect, useRef, useState } from "react";
// import { Section, Wrapper, LogoImg, Links, Link, LinksElement, Contact, ContactButton} from "./Header.styled";
import styles from "./Header.module.scss";
import Logo from "../../assets/images/header/Logo.svg";
import Burger from "../../assets/images/header/burger.svg";
import { IoIosPhonePortrait } from "react-icons/io";
import { TfiEmail } from "react-icons/tfi";
import { AsideMenu } from "../AsideMenu/AsideMenu";
import { useAsideMenuIsOpen } from "../../hooks/useAsideMenuIsOpen";

export const Header = () => {
  const lastScrollTop = useRef(0);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const { isOpen, setIsOpen } = useAsideMenuIsOpen();

  const handleScroll = () => {
    const { pageYOffset } = window;
    if (pageYOffset > lastScrollTop.current) {
      //downward scroll
      setIsNavbarVisible(false);
    } else if (pageYOffset < lastScrollTop.current) {
      //upward scroll
      setIsNavbarVisible(true);
    } // else was horizontal scroll
    lastScrollTop.current = pageYOffset;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const {
    section__header,
    section__wrapper,
    section__wrapper_visible,
    header__logo,
    header__links,
    header__contact,
    header__linksElement,
    header__button,
  } = styles;

  return (
    <header className={section__header} id="headerLogo">
      <div
        className={
          isNavbarVisible ? section__wrapper : section__wrapper_visible
        }
      >
        <nav>
          <ul>
            <li>
              <a href="#headerLogo">
                <img className={header__logo} src={`${Logo}`} alt="Logo" />
              </a>
            </li>
            <li>
              <ul className={header__links}>
                <li className={header__linksElement}>
                  <a href="#about">O mnie</a>
                </li>
                <li className={header__linksElement}>
                  <a href="#projects">Portfolio</a>
                </li>
                <li className={header__linksElement}>
                  <a href="#contact">Kontakt</a>
                </li>
              </ul>
            </li>

            <li>
              <ul className={header__contact}>
                <li className={header__linksElement}>
                  {/* <p>
                    <a href="tel:+514510313">Zadzwoń</a>
                  </p> */}
                  <p>
                    <a href="tel:+514510313"><IoIosPhonePortrait />514-510-313</a>
                  </p>
                </li>
                <li className={header__linksElement}>             
                    <a href="mailto:mierzejewski2you@gmail.com">
                      <button className={header__button}><TfiEmail />Napisz</button>
                    </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <button onClick={() => setIsOpen(true)} >
          <img src={`${Burger}`} height='40px' width='40px' alt="Burger" />
        </button>
      </div>
      <AsideMenu isOpen={isOpen} setIsOpen={setIsOpen} />
    </header>
  );
};
